import CalculatorOutputCard from './CalculatorOutputCard';
export default CalculatorOutputCard;
